/**
 * @file 首页
 * @author gaoxunchen
 */

import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import dayjs from 'dayjs';

import { hasPurview, hasFeatureFlag } from '@/services';
import globalStore from '@/stores';
import { getCommonConfig } from '@/api/wuji';

import CardCostSummary from './components/card-cost-summary';
import CardCostDetail from './components/card-cost-detail';
import CardTask from './components/card-task';
import CardAccountEffect from './components/card-accout-effect';
import HomeSaleTodo from '@/business-components/sale/HomeSaleTodo/index';
import HomeSaleBoard from '@/business-components/sale/HomeSaleBoard/index';
import CardAssets from './components/card-assets';
import Announcement from './components/announcement';
import Advertising from './components/advertising';
import DialogWelcome from './components/dialog-welcome';
import AuthUserTypeDialog from './components/user-auth';

import './index.scoped.less';

const Container: React.FC = () => {
  const { account } = globalStore;
  const { operator_name } = account || {};
  const [config, setConfig] = useState<Record<string, any>>({});

  useEffect(() => {
    getConfig();
  }, []);

  const schemaMap = {
    'card-cost-summary': {
      component: CardCostSummary,
    },
    'card-cost-detail': {
      component: CardCostDetail,
    },
    'card-task': {
      component: CardTask,
    },
    'card-account-effect': {
      component: CardAccountEffect,
    },
    'card-announcement': {
      component: Announcement,
    },
    'card-advertising': {
      component: Advertising,
    },
    'home-sale-data': {
      component: HomeSaleBoard,
    },
    'home-sale-todo': {
      component: HomeSaleTodo,
    },
    'card-assets': {
      component: CardAssets,
    },
  };

  const schema = _.get(config, 'home', []).map((v: any) => ({
    ...v,
    ...(schemaMap[v?.key] || {}),
  }));

  const getConfig = async () => {
    try {
      const { code, data } = await getCommonConfig({
        filter: 'key=home_config',
      }) as Record<string, any>;
      if (code === 200) {
        const config = JSON.parse(_.get(data, '0.config', '{}'));
        setConfig(config);
        // 首屏置灰
        if (config?.bodyGray) {
          (document.querySelector('#root'))?.classList.add('body-gray');
        }
      }
    } catch (error) {
    }
  };

  if (_.isEmpty(schema)) {
    return <Loading />;
  }

  return (
    <div className="home">
      <div className="home-header">
        <div className="title">{`${operator_name}，${dayjs().hour() < 13 ? '上午' : '下午'}好`}</div>
        <AuthUserTypeDialog />
      </div>
      <div className="home-body">
        {
          schema.map((v: any) => {
            const { key, title, component: Component, componentProps = {}, perm, permType = 'allOf', enableKey } = v;
            if (perm && !hasPurview(perm, permType)) {
              return null;
            }
            if (enableKey && !hasFeatureFlag(enableKey)) {
              return null;
            }
            if (!Component) {
              return null;
            }
            return (
              <Component
                key={key}
                schema={_.get(config, key, {})}
                {...componentProps}
                {...{
                  title,
                  perm,
                  account,
                }}
              />
            );
          })
        }
      </div>
      <DialogWelcome
        schema={_.get(config, 'dialog-welcome', {})}
      />
    </div>
  );
};

export default Container;
